<template>
  <div class="box6">
    <pageTitle title="知名校友" />
    <div class="content-box">
      <div class="wraper-box">
        <div
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="box">
            <img :src="item.pic" alt="" />
            <p>{{ item.text }}</p>
          </div>
          <div class="box">
            <img :src="item.pic2" alt="" />
            <p>{{ item.text2 }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},

  data() {
    return {
      list: [
        {
          text: "美国著名管理学家，经济学家，被后世称为“科学管理之父”，其代表作为《科学管理原理》",
          pic: require("../../../assets/coursePage/stevens/box6/pic1.png"), 
          text2: "世界顶级技术作家，Windows编程大师，代表作《图灵的秘密:A Guided Tour through Alan Turing's Historic Paper on Computability and the Turing Machine》等",
          pic2: require("../../../assets/coursePage/stevens/box6/pic4.png"), 
        },
        {
          text: "中微子的发现者，1995年诺贝尔物理学奖获得者",
          pic: require("../../../assets/coursePage/stevens/box6/pic2.png"), 
          text2: "美国工程院院士、中国科学院外籍院士，现任美国恩理化学技术公司总裁，荣获国际化工著名奖项珀金奖章、国际化工终身成就奖等多项殊荣",
          pic2: require("../../../assets/coursePage/stevens/box6/pic5.png"), 
        },
        {
          text: "甘特图的发明者，是泰勒创立和推广科学管理制度的亲密的合作者，也是科学管理运动的先驱者之一",
          pic: require("../../../assets/coursePage/stevens/box6/pic3.png"), 
          text2: "联合国助理秘书长、联合国开发计划署助理署长兼开发署亚太局局长，是非中国政府委派的在联合国任职的最高级别的中国籍官员",
          pic2: require("../../../assets/coursePage/stevens/box6/pic6.png"), 
        },
      ],
      swiperOption: {
        loop: false, // 循环模式选项
        slidesPerView: 1.4,
        spaceBetween: 20,
        // centeredSlides: true,
      },
    };
  },
  computed: {

  },
  methods: {

  },
};
</script>

<style lang="less" scoped>
.box6 {
  font-family: PingFangSC, PingFang SC;
  padding: 80px 0;
  width: 100%;
  background: #F3F3F9;
  box-sizing: border-box;
  /deep/.course-title-box .course-title {
    font-weight: 600;
    font-size: 44px;
    color: #272020;
    line-height: 64px;
    text-align: center;
  }
  .content-box {
    width: 750px;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
      width: 0 !important;
      height: 0 !important;
      color: transparent;
    }
    .wraper-box {
      box-sizing: border-box;
      padding: 0 40px;
      width: 1740px;
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
    }
    .swiperwrap {
      margin-right: 40px;
    }
    .box {
      width: 526px;
      min-height: 428px;
      img {
        margin-top: 40px;
        width: 100%;
      }
      p {
        margin-top: 32px;
        font-size: 26px;
        color: #272020;
        line-height: 44px;
        text-align: left;
      }
    }
    .swiperwrap:first-child {
      .box:last-child {
        p {
          font-size: 25.5px;
        }
      }
    }
  }
}
</style>
